import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translations from './locales/translations.json';

// Date formatting utilities based on locale
export const getDateLocale = (lang) => {
  const locales = {
    en: 'en-US',
    es: 'es-ES',
    pt: 'pt-BR'
  };
  return locales[lang] || 'en-US';
};

// Format date based on current language
export const formatDate = (date, lang, options = {}) => {
  const locale = getDateLocale(lang);
  const defaultOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options
  };
  return new Intl.DateTimeFormat(locale, defaultOptions).format(date);
};

// Format short date (for schedule)
export const formatShortDate = (date, lang) => {
  const locale = getDateLocale(lang);
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  }).format(date);
};

// Format weekday
export const formatWeekday = (date, lang, style = 'long') => {
  const locale = getDateLocale(lang);
  return new Intl.DateTimeFormat(locale, { weekday: style }).format(date);
};

// Currency formatting (if needed in future)
export const formatCurrency = (amount, lang, currency = 'USD') => {
  const locales = {
    en: 'en-US',
    es: 'es-ES',
    pt: 'pt-BR'
  };
  const currencies = {
    en: 'USD',
    es: 'EUR',
    pt: 'BRL'
  };
  return new Intl.NumberFormat(locales[lang] || 'en-US', {
    style: 'currency',
    currency: currency || currencies[lang] || 'USD'
  }).format(amount);
};

// Language configuration
export const LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇺🇸', shortName: 'EN' },
  { code: 'es', name: 'Español', flag: '🇪🇸', shortName: 'ES' },
  { code: 'pt', name: 'Português', flag: '🇧🇷', shortName: 'PT' }
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: translations,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // React already does escaping
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'lumon-lang',
    }
  });

export default i18n;
